import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {
	
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{							
						case 'pendientesFtn': 
							await this.updateDataPost({ data: {
								data: [],
								tablaPost:['datos_afiliado','notas_pendientes'],
								tablaDelete: [],
								notaDelete:null,
								tablaAuditar: true, 
								route: 'save_all'
							}})							
						break
						case 'inactivarFtn': 
							await this.updateDataPost({ data: {
								data: [],
								tablaPost:['notas_pendientes'],
								tablaDelete: [],
								tablaAuditar: true, 
								route: 'save_all'
							}})
						break
					}
				}

				await this.save(event.save,event.savePost)

				const await30 = this.getDataGet({route: 'get_notaspendientes', data: {others: [ ['id_list_mes', this.mes_periodo.id], ['id_list_ano', this.ano_periodo.id]]}})
				const await00 = this.resetGlobal({state: 'saveConfig/capa'})
				const await01 = this.resetGlobal({state: 'openModal'})
				const await02 = this.resetDataPost({state: 'data'}) 
				const await03 = this.resetDataForm() 
				const await04 = this.resetDataIndex() 
				await Promise.all([await00,await01,await02,await03,await04,await30])
				
			}
			catch(e){
				console.log('error save aportes registro')

			}			
		}	
	},
}
